import { Component, inject, Input } from '@angular/core';
import { Job } from '../../class/job.class';
import { Observable, of } from 'rxjs';
import { Task } from '../../class/task.class';
import { Store } from '@ngrx/store';
import { selectLastTask } from '../../store/jobs/jobs.selects';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-progress-job-counter',
  imports: [NgClass],
  template: `
    <div class="progress-number-container" [ngClass]="job?.status || 'PENDING'">
      <p class="progress-number">{{ job?.completedPercent || 0 }}%</p>
    </div>
  `,
  styleUrl: './progress-job-counter.component.scss',
})
export class ProgressJobCounterComponent {
  store: Store = inject(Store);

  @Input() job: Job | undefined = undefined;
  $activeTask: Observable<Task | undefined> = of(undefined);

  ngOnInit(): void {
    if (this.job) {
      this.$activeTask = this.store.select(selectLastTask(this.job.id));
    }
  }
}
